<template>
  <div class="message">
    <div class="title-box"><span class="title">MESSAGES</span></div>
    <div class="lists">
      <div
        v-for="(item, index) in messages"
        :key="index"
        @click="detail(item.id)"
      >
        <message-box-photographer :messages="item"> </message-box-photographer>
      </div>
    </div>
  </div>
</template>

<script>
import { getMessagesForPhotographer } from '../../api/message'
import MessageBoxPhotographer from '../common/MessageBoxPhotographer'

export default {
  name: 'message',
  components: { MessageBoxPhotographer },
  data() {
    return {
      messages: []
    }
  },
  created() {
    this.getMessage()
  },
  methods: {
    getMessage() {
      getMessagesForPhotographer(this.$store.getters.userInfo.uid).then(res => {
        console.log('message lists:', res)
        this.messages.push(...res)
      })
    },
    detail(serviceId) {
      console.log('service id: ', serviceId)
      this.$router.push({
        path: '/photographer/message/' + serviceId
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.message {
  .title-box {
    width: 1080px;
    height: 60px;
    background-color: #ffffff;
    border-left: solid 1px #e7e7e7;
    border-top: solid 1px #e7e7e7;
    border-right: solid 1px #e7e7e7;
    text-align: center;
    .title {
      line-height: 60px;
      font-size: 16px;
      font-weight: 600;
      letter-spacing: 1px;
      text-align: center;
      color: #ab08b6;
    }
  }

  .lists {
    margin: 30px 0 0 0;
    .message-box-photographer {
      margin-bottom: 20px;
    }
  }
}
</style>
